import React from 'react';
import { Table, Loader, Button, Header, Icon, Segment, Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import numeral from 'numeral';
import _ from 'lodash';
import DemographicsAgeGraph from 'dyzio-shared-components/lib/components/demographics-age-graph';
import { tabulateDemographics } from '../../utils/demographics-functions';

// const TEAM_DYZIO_ID = 'f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96';
// const DC = 'fdd20559-e10d-4b07-834c-7882c127e82e';
// const JONPLE = 'f4412f47-6788-47ac-84c9-dae56067a8c1';
// const HERE_AND_NOW = '15e0ffdb-bd62-4eaf-b8ba-fb242ebc6fd6';

const DEMOGRAPHICS_REFRESH_INTERVAL = 30000;

const notificationStyle = {
  paddingTop: 20,
  paddingBottom: 20,
};

const demographicsLoadingStyle = {
  minHeight: 90,
  marginTop: 30,
};

const messageStyle = { color: 'grey', fontSize: 16 };

class DyzioDemographics extends React.Component {
  constructor() {
    super();
    this.state = {
      demographicsStatus: 'LOADING',
      demographicsData: {},
    };
    this.restClient = axios.create({
      baseURL: process.env.REACT_APP_DEMOGRAPHICS_SERVICE_API,
      timeout: 5000,
    });

    axiosRetry(this.restClient, {
      delay: 100,
      retries: 3,
    });
  }

  componentDidMount() {
    this.loadDemographics();
  }

  componentWillUnmount() {
    console.log('unmounting');
    if (this.state.intervalId) {
      this.stopDemographicsStatusRefresh();
    }
  }

  startDemographicsStatusRefresh = () => {
    if (!this.state.intervalId) {
      const intervalId = setInterval(this.loadDemographics, DEMOGRAPHICS_REFRESH_INTERVAL);
      this.setState({ intervalId });
    }
  }

  stopDemographicsStatusRefresh = () => {
    clearInterval(this.state.intervalId);
  }

  isDemographicsEmpty = demographics => {
    const male65 = _.get(demographics, 'M65-.percentage', null);
    return male65 === null;
  }

  loadDemographics = () => {
    console.log('LOAD AI DEMPGRAPHICS');
    const profile = this.props.influencer;
    const { instagram } = profile;
    if (instagram) {
      this.setState({
        demographicsStatus: 'LOADING',
      });
      this.restClient.get(`/influencers/demographics/dyzio/${instagram}`).then(response => {
        const { status, data } = response.data;
        console.log(status, data);
        if (status === 200) {
          if (this.isDemographicsEmpty(data.dyzioDemographics)) {
            this.setState({
              demographicsStatus: 'SENT_FOR_ANALYSIS',
            });
            this.startDemographicsStatusRefresh();
          } else {
            this.setState({
              demographicsStatus: 'GENERATED_OK',
              demographicsData: data.dyzioDemographics,
            });
            console.log('Dyzio AI DEMPGRAPHICS Retrieved');
            this.stopDemographicsStatusRefresh();
          }
        }
        if (status === 204) {
          this.setState({
            demographicsStatus: 'NOT_SENT',
          });
        }
      }).catch(err => {
        console.log('err', err);
        this.setState({
          demographicsStatus: 'NOT_SENT',
        });
      });
    }
    this.setState({
      brandMentionsData: null,
      brandMentionsLoading: false,
    });

    return null;
  }

  onClick = () => {
    const { instagram, instagramId, id } = this.props.influencer;
    const instagramUsername = instagram;
    console.log(instagramUsername, instagramId);
    this.setState({
      demographicsStatus: 'LOADING',
    });
    const payload = {
      data: {
        forceScan: true,
        influencer: {
          username: instagramUsername,
          instagramId,
          id,
        },
      },
    };
    this.restClient.post('/influencers/process', payload).then(response => {
      console.log(response.data);
      this.setState({
        demographicsStatus: 'SENT_FOR_ANALYSIS',
      });
      this.startDemographicsStatusRefresh();
    }).catch(err => {
      console.log('err', err);
      this.setState({
        demographicsStatus: 'SENT_FOR_ANALYSIS',
      });
      this.startDemographicsStatusRefresh();
    });
  };

  render() {
    const { demographicsStatus } = this.state;
    const { instagram } = this.props.influencer;
    const instagramUsername = instagram;
    return (
      <div>
        {
          this.getComponent(demographicsStatus, instagramUsername)
        }
      </div>
    );
  }

  NotSentState = instagramUsername => {
    const organisationId = this.props.organisationId;
    console.log('organisationId', organisationId);
    return (
      <Segment>
        <Grid columns={3}>
          <Grid.Row>
            <Grid.Column width={3}>
              <h3>Dyzio AI Demographics</h3>
              <br />
              <p>
                Dyzio uses AI technology, combined with real
                Instagram demographic data and our own proprietary
                algorithm to estimate Instagram audience demographics.
              </p>
              <br />
              <p>Influencer demographics direct from Instagram,
                 YouTube and Facebook are available via influencer
                authentication (Premium Feature).</p>
            </Grid.Column>
            <Grid.Column width={13} verticalAlign="middle">
              <Header as="h2" icon textAlign="center" style={notificationStyle}>
                <Header.Content style={messageStyle}>
                  {instagramUsername} Instagram account has not been analysed yet
                </Header.Content>
                <Button
                  centre
                  color="pink"
                  content="Analyse AI demographics now"
                  onClick={this.onClick}
                  // disabled={organisationId === HERE_AND_NOW}
                />
              </Header>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  };

  SentState = instagramUsername => (
    <Segment>
      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column width={3}>
            <h3>Dyzio AI Demographics</h3>
            <br />
            <p>Dyzio is currently analysing {instagramUsername}’s audience.
             The page will refresh in a couple of minutes,
             when the data is available.</p>
          </Grid.Column>
          <Grid.Column width={13} verticalAlign="middle">
            <Header as="h2" icon textAlign="center" style={notificationStyle}>
              <Header.Content style={messageStyle}>
                {instagramUsername} is being analysed
              </Header.Content>
              <Icon name="clock outline" color="orange" circular />
            </Header>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );

  GeneratedState = instagramUsername => {
    const { demographicsData } = this.state;
    const audienceDemographics = { data: demographicsData };
    console.log('demographicsData', audienceDemographics);
    const { demographicsTable, total } = tabulateDemographics(audienceDemographics.data);
    return (
      <Segment>
        <Grid columns={3}>
          <Grid.Row>
            <Grid.Column width={3}>
              <h3>Dyzio AI Demographics</h3>
              <br />
              <p>{instagramUsername}’s Instagram demographic data is estimated using AI technology,
              combined with real demographic data from Instagram and Dyzio’s own proprietary algorithm.</p>
              <br />
              <p>Influencer demographics direct from Instagram,
                YouTube and Facebook are available via influencer authentication (Premium Feature).</p>
            </Grid.Column>
            <Grid.Column width={8} textAlign="center">
              <h5>Channel demographic by gender / age</h5>
              <DemographicsAgeGraph audienceDemographics={audienceDemographics} />
            </Grid.Column>
            <Grid.Column width={5}>
              <Table basic="very" columns="three" singleLine textAlign="center" sortable="true">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell textAlign="left">Age Group</Table.HeaderCell>
                    <Table.HeaderCell>Male</Table.HeaderCell>
                    <Table.HeaderCell>Female</Table.HeaderCell>
                    <Table.HeaderCell>Total</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {
                    _.map(demographicsTable, ([key, value]) => <Table.Row>
                      <Table.Cell textAlign="left">
                        {key}
                      </Table.Cell>
                      <Table.Cell>
                        {value.M.percentage}%
                      </Table.Cell>
                      <Table.Cell>
                        {value.F.percentage}%
                      </Table.Cell>
                      <Table.Cell>
                        {numeral(value.M.percentage + value.F.percentage).format('0.0')}%
                      </Table.Cell>
                    </Table.Row>)
                  }
                  <Table.Row>
                    <Table.Cell textAlign="left">
                        Total
                    </Table.Cell>
                    <Table.Cell>
                      <Header as="b" textAlign="center">
                        {numeral(total.M).format('0.0')}%
                      </Header>
                    </Table.Cell>
                    <Table.Cell>
                      <Header as="b" textAlign="center">
                        {numeral(total.F).format('0.0')}%
                      </Header>
                    </Table.Cell>
                    <Table.Cell />
                  </Table.Row>
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  };

  LoadingState = () => (
    <Segment>
      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column width={3}>
            <h3>Dyzio AI Demographics</h3>
            <br />
            <p>Dyzio uses AI technology, combined with real Instagram demographic
              data and our own proprietary algorithm to estimate Instagram audience demographics.</p>
            <br />
            <p>Influencer demographics direct from Instagram, YouTube and
              Facebook are available via influencer authentication (Premium Feature).</p>
          </Grid.Column>
          <Grid.Column width={13} verticalAlign="middle">
            {
              true &&
              <Loader
                active
                inline="centered"
                content="Loading demographics data"
                style={demographicsLoadingStyle}
              />
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );

  getComponent = (state, instagramUsername) => {
    const components = {
      NOT_SENT: this.NotSentState(instagramUsername),
      SENT_FOR_ANALYSIS: this.SentState(instagramUsername),
      GENERATED_OK: this.GeneratedState(instagramUsername),
      LOADING: this.LoadingState(),
    };
    const component = components[state];
    return component;
  };
}

DyzioDemographics.propTypes = {
  influencer: PropTypes.object.isRequired,
  organisationId: PropTypes.string.isRequired,
};

export default DyzioDemographics;



/** WEBPACK FOOTER **
 ** ./src/containers/dyzio-demographics/index.js
 **/